import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = {
  class: "relative h-screen flex flex-col justify-between bg-white",
  style: {"width":"733px"}
}
const _hoisted_3 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_4 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4" }, "Topup Saldo", -1)
const _hoisted_6 = { class: "flex flex-col pr-2" }
const _hoisted_7 = { class: "flex px-8 flex-row gap-x-10 text-16px" }
const _hoisted_8 = { class: "font-normal" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { id: "snackbar" }, "Copied", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalTabTopupVa = _resolveComponent("ModalTabTopupVa")!
  const _component_ModalTabTopupManual = _resolveComponent("ModalTabTopupManual")!
  const _component_ModalDetailCashback = _resolveComponent("ModalDetailCashback")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["justify-end items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none", { 'pb-4': _ctx.isShowRunningText }]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("img", {
                src: _imports_0,
                class: "w-4 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                alt: "x"
              })
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredTabs, (tab) => {
                return (_openBlock(), _createBlock("button", {
                  key: tab.name,
                  onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
                  class: 
                  `pb-2 pt-4 font-semibold hover:text-red-lp-100 focus:outline-none ${
                    tab.name === _ctx.activeTab
                      ? 'text-red-lp-100 border-b-2 border-red-lp-100'
                      : 'text-gray-lp-600 border-b-2 border-white'
                  }`
                
                }, [
                  _createTextVNode(_toDisplayString(tab.title) + " ", 1),
                  _createVNode("span", _hoisted_8, _toDisplayString(tab.name === "manual" ? "(Verifikasi Manual)" : ""), 1)
                ], 10, ["onClick"]))
              }), 128))
            ]),
            (_ctx.activeTab === 'va')
              ? (_openBlock(), _createBlock(_component_ModalTabTopupVa, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'manual')
              ? (_openBlock(), _createBlock(_component_ModalTabTopupManual, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_9
    ], 2),
    _hoisted_10,
    _createVNode(_component_ModalDetailCashback, {
      data: _ctx.dataTiers,
      startDate: _ctx.startDateCashback,
      endDate: _ctx.endDateCashback
    }, null, 8, ["data", "startDate", "endDate"])
  ]))
}